module.exports = __webpack_public_path__ + "img/BRCA1_pDC.7b1ed31b.png";